import { Injectable } from '@angular/core';
import { ReservaRepository } from '@data/repository/reserva/reserva.repository';
import { CupomEntity } from '@domain/dto/reserva/reserva-cupom-get.dto';
import { ReservaEntity } from '@domain/dto/reserva/reserva-post.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReservaUsecase {
  constructor(private repository: ReservaRepository) {}

  insert(param: ReservaEntity): Observable<ReservaEntity> {
      return this.repository.insert(param);
  }

  getById(cupom: string): Observable<CupomEntity> {
    return this.repository.getById(cupom);
  }

  getCustomById(field: string, value: string): Observable<any> {
    return this.repository.getCustomById(field, value);
  }
}
